import {
  isModalNumber,
  isReportModalOpened,
} from '@/features/Discovery/discovery.state';

import { useRouter } from 'next/navigation';
import { useSetAtom } from 'jotai';

export const useModalControl = () => {
  const { back } = useRouter();
  const setOpen = useSetAtom(isModalNumber);

  const setReportModalVisible = useSetAtom(isReportModalOpened);

  const closeModal = () => {
    setOpen(0);
    back();
  };

  const openReportModal = () => {
    setReportModalVisible(true);
  };

  return { closeModal, openReportModal };
};
